import Packaging from "../packaging";
import {qs, qsa, indexOfElementNode} from "../utils/core";

class ExPackaging extends Packaging{
	constructor(packageDocument, booksSetting){
		super(packageDocument);
		let {layout, encryptType, downloadToken, checksum, baseUrl, directory} = booksSetting;
		this.fixParse(packageDocument, layout, encryptType, downloadToken, checksum, baseUrl, directory);
	}

	/**
	 * Parse OPF XML, remove return
	 * @param  {document} packageDocument OPF XML
	 */
	parse(packageDocument){
		var metadataNode, manifestNode, spineNode;

		if(!packageDocument) {
			throw new Error("Package File Not Found");
		}

		metadataNode = qs(packageDocument, "metadata");
		if(!metadataNode) {
			throw new Error("No Metadata Found");
		}

		manifestNode = qs(packageDocument, "manifest");
		if(!manifestNode) {
			throw new Error("No Manifest Found");
		}

		spineNode = qs(packageDocument, "spine");
		if(!spineNode) {
			throw new Error("No Spine Found");
		}    
		this.manifest = this.parseManifest(manifestNode);
		this.navPath = this.findNavPath(manifestNode);
		this.ncxPath = this.findNcxPath(manifestNode, spineNode);
		this.coverPath = this.findCoverPath(packageDocument);

		this.spineNodeIndex = indexOfElementNode(spineNode);

		this.spine = this.parseSpine(spineNode, this.manifest);

		this.uniqueIdentifier = this.findUniqueIdentifier(packageDocument);
		this.metadata = this.parseMetadata(metadataNode);

		this.metadata.direction = spineNode.getAttribute("page-progression-direction") || "ltr";
		if(this.metadata.direction === "default"){
			this.metadata.direction = "ltr";
		}

		this.metadata.defaultDirection = this.metadata.direction;
	}

	/**
	 * fix coverPath, metadata.layout, metadata.orientation, metadata.spread, navPath, ncxPath and add epubVersion
	 * @param  {document} packageDocument OPF XML
     * @param  {string} layout
	 * @return {object} parsed package parts
	 */
	 fixParse(packageDocument, layout, encryptType, downloadToken, checksum, baseUrl, directory){
		
		this.epubVersion = this.findEpubVersion(packageDocument);

		if(encryptType  === "enc01"){
			let manifestNode = qs(packageDocument, "manifest");
			this.manifest = this.fixParseManifest(manifestNode, downloadToken, checksum, baseUrl, directory);
		}

		//console.log(checksum, baseUrl, directory);
		//let directoryUrl = `${baseUrl}${directory}/`;
		//console.log(directoryUrl);

		/*if(this.coverPath !== ""){
			console.log(this.coverPath);
		}*/

		if(this.metadata.layout == ""){
			this.metadata.layout = layout;
		}

		if(this.metadata.orientation == ""){
			this.metadata.orientation = "auto";
		}

		if(this.metadata.spread == ""){
			this.metadata.spread = "auto";
		}

		return {
			"epubVersion" : this.epubVersion,
			"metadata" : this.metadata,
			"spine"    : this.spine,
			"manifest" : this.manifest,
			"navPath"  : this.navPath,
			"ncxPath"  : this.ncxPath,
			"coverPath": this.coverPath,
			"spineNodeIndex" : this.spineNodeIndex
		};
	}

	/**
	 * Parse Manifest
	 * @private
	 * @param  {node} manifestXml
	 * @return {object} manifest
	 */
	 fixParseManifest(manifestXml, downloadToken, checksum, baseUrl, directory){
		var manifest = {};

		//-- Turn items into an array
		// var selected = manifestXml.querySelectorAll("item");
		var selected = qsa(manifestXml, "item");
		var items = Array.prototype.slice.call(selected);
		let directoryUrl = `${baseUrl}${directory}/`;

		//-- Create an object with the id as key
		items.forEach(function(item){
			var id = item.getAttribute("id"),
					href = item.getAttribute("href") || "",
					type = item.getAttribute("media-type") || "",
					overlay = item.getAttribute("media-overlay") || "",
					properties = item.getAttribute("properties") || "",
					token = "";

			//將章節(xhtml、html、ncx)加入token屬性
			if(href.search(/^.*\.(xhtml|html|htm|ncx)/i) !== -1){
				token = downloadToken;
			}

			manifest[id] = {
				"href" : href,
				//"url" : url,
				"token": token,
				"type" : type,
				"overlay" : overlay,
				"properties" : properties.length ? properties.split(" ") : []
			};

		});

		return manifest;

	}

	/**
	 * Find the EPUB Version
	 * @private
	 * @param  {node} packageXml
	 * @return {string} version
	 */
	findEpubVersion(packageXml){
		var pkg = qs(packageXml, "package");
		return pkg.getAttribute("version");
	}
}

export default ExPackaging;